import { useEffect, useState } from 'react';
import { supabase } from '../services/supabaseClient';

export const useCalendar = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [userPlan, setUserPlan] = useState('weekly');

  useEffect(() => {
    const fetchCalendarData = async () => {
      setLoading(true);
      try {
        const { data: { user } } = await supabase.auth.getUser();
        const plan = user?.user_metadata?.plan || 'weekly';
        setUserPlan(plan);

        const { data, error } = await supabase
          .from('calendar_dates')
          .select('*')
          .ilike('type', `%${plan}%`);

        if (error) throw error;
        setEvents(data || []);
      } catch (err) {
        console.error(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchCalendarData();
  }, []);

  return { events, loading, userPlan };
};